let allPoints;
let allHeroes;
let allBodies;

const init = () => {
  allPoints = document.querySelectorAll('.js-botany-point');
  allHeroes = document.querySelectorAll('.js-botany-hero');
  allBodies = document.querySelectorAll('.js-botany-content');
  allPoints.forEach((el) => el.addEventListener('click', changeBotanySection));
};

const changeBotanySection = (event) => {
  const point = event.target;
  const index = Array.from(allPoints).indexOf(point);

  // remove is-current from all points and sections
  allPoints.forEach(p => p.classList.remove('is-current'));
  allHeroes.forEach(s => s.classList.remove('is-current'));
  allBodies.forEach(s => s.classList.remove('is-current'));

  // add is-current to clicked point and equivalent section
  point.classList.add('is-current');
  allHeroes[index].classList.add('is-current');
  allBodies[index].classList.add('is-current');
};

export default {init};
